var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F4F4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 13.75,
    width: 25.5,
    height: 22.5,
    rx: 1.25,
    stroke: "#5E5E5E",
    strokeOpacity: 0.19,
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3506,
    y: 16.75,
    width: 3.9,
    height: 3.9,
    rx: 1.95,
    stroke: "#5E5E5E",
    strokeOpacity: 0.19,
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2498,
    y: 17.0501,
    width: 8.7,
    height: 0.9,
    rx: 0.45,
    stroke: "#5E5E5E",
    strokeOpacity: 0.19,
    strokeWidth: 0.9
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15.3496,
    y: 25.1499,
    width: 17.7,
    height: 8.1,
    rx: 1.25,
    stroke: "#5E5E5E",
    strokeOpacity: 0.19,
    strokeWidth: 1.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2498,
    y: 19.45,
    width: 5.1,
    height: 0.9,
    rx: 0.45,
    stroke: "#5E5E5E",
    strokeOpacity: 0.19,
    strokeWidth: 0.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.cdaea74047dd16aee04d4da76e3b78e8.svg";
export { ForwardRef as ReactComponent };